/* =========================================================
   OTP Gate — تأكيد رقم جوال العميل قبل إتمام الطلب
   ملف مستقل تمامًا. الإعدادات بتيجي من window.OTP_GATE (snippet).
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.OTP_GATE || {};
  var WORKER = String(CFG.worker || '').replace(/\/+$/, '');
  var ROOT = CFG.root || '/';
  var TTL_MS = (Number(CFG.ttlHours) || 24) * 60 * 60 * 1000;
  var RESEND_SEC = Number(CFG.resendSeconds) || 30;
  var CODE_LEN = Number(CFG.codeLength) || 4;
  var PREFILL = String(CFG.prefillPhone || '').trim();
  var DEBUG = !!CFG.debug;

  var STORE_KEY = 'otp_gate_v1';

  if (!WORKER) {
    if (DEBUG) console.warn('[OTP Gate] worker URL مش متظبط — الاسكربت متوقف.');
    return;
  }

  /* ---------------------------------------------------------
     1) الأزرار اللي بنعترضها
     --------------------------------------------------------- */

  // أزرار الشيك أوت العادية (الكارت درور + صفحة الكارت)
  var CART_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-checkout]',
    '.cart-checkout-btn',
    '.cart__checkout',
    '.cart__checkout-button',
    '.cart-drawer__checkout',
    '.btn--checkout',
    '.checkout-button',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]'
  ].join(',');

  // زرار "اشترِ الآن" (Dynamic checkout)
  var BUYNOW_SELECTOR = [
    '.shopify-payment-button__button',
    '.shopify-payment-button__button--unbranded'
  ].join(',');

  var ALL_SELECTOR = CART_SELECTOR + ',' + BUYNOW_SELECTOR;

  /* ---------------------------------------------------------
     2) التخزين المحلي
     --------------------------------------------------------- */

  function readStore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.phone || !obj.t) return null;
      if (Date.now() - obj.t > TTL_MS) {
        localStorage.removeItem(STORE_KEY);
        return null;
      }
      return obj;
    } catch (e) {
      return null;
    }
  }

  function writeStore(phone, token) {
    try {
      localStorage.setItem(
        STORE_KEY,
        JSON.stringify({ phone: phone, token: token || '', t: Date.now() })
      );
    } catch (e) {}
  }

  function isVerified() {
    return !!readStore();
  }

  /* ---------------------------------------------------------
     3) أدوات مساعدة
     --------------------------------------------------------- */

  function normalizePhone(input) {
    var p = String(input || '').replace(/[\s\-()]/g, '');
    p = p.replace(/[\u0660-\u0669]/g, function (d) {
      return String(d.charCodeAt(0) - 1632);
    }); // أرقام عربية -> إنجليزية
    p = p.replace(/[\u06F0-\u06F9]/g, function (d) {
      return String(d.charCodeAt(0) - 1776);
    });
    if (p.indexOf('+966') === 0) return p;
    if (p.indexOf('00966') === 0) return '+' + p.slice(2);
    if (p.indexOf('966') === 0) return '+' + p;
    if (p.indexOf('0') === 0) return '+966' + p.slice(1);
    if (p.indexOf('5') === 0) return '+966' + p;
    return p;
  }

  function isValidSaudi(e164) {
    return /^\+9665\d{8}$/.test(e164);
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {})
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { ok: false, message: 'تعذّر الاتصال. تحقق من الإنترنت وحاول مرة أخرى.' };
      });
  }

  // ترحيل الرقم إلى بيانات السلة -> يظهر في "تفاصيل إضافية" داخل الطلب
  function syncCartAttributes(phone) {
    return fetch(ROOT.replace(/\/$/, '') + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'رقم الجوال المؤكد': phone,
          otp_phone: phone,
          otp_verified: '1',
          otp_verified_at: new Date().toISOString()
        }
      })
    }).catch(function () {});
  }

  /* ---------------------------------------------------------
     4) بناء البوب أب (مرة واحدة)
     --------------------------------------------------------- */

  var els = {};
  var state = { trigger: null, phone: '', timerId: null, busy: false };

  function buildModal() {
    if (els.overlay) return;

    var overlay = document.createElement('div');
    overlay.className = 'otpg-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'otpg-title');
    overlay.innerHTML =
      '<div class="otpg-panel">' +
      '<button type="button" class="otpg-close" aria-label="إغلاق">&times;</button>' +

      /* الخطوة 1 */
      '<div class="otpg-step is-active" data-step="1">' +
      '<h2 class="otpg-title" id="otpg-title">تأكيد رقم الجوال</h2>' +
      '<p class="otpg-sub">أدخل رقم جوالك لنرسل لك رمز تحقق قبل إتمام الطلب.</p>' +
      '<input class="otpg-field" data-phone type="tel" dir="ltr" inputmode="tel" autocomplete="tel" placeholder="05XXXXXXXX">' +
      '<button type="button" class="otpg-btn" data-send>إرسال رمز التحقق</button>' +
      '<div class="otpg-msg" data-msg1></div>' +
      '</div>' +

      /* الخطوة 2 */
      '<div class="otpg-step" data-step="2">' +
      '<h2 class="otpg-title">أدخل رمز التحقق</h2>' +
      '<p class="otpg-sub">أرسلنا رمزًا من ' + CODE_LEN + ' أرقام إلى <b data-phone-label></b></p>' +
      '<div class="otpg-code-wrap">' +
      '<input class="otpg-code" data-code type="tel" inputmode="numeric" pattern="[0-9]*" ' +
      'autocomplete="one-time-code" maxlength="' + CODE_LEN + '" placeholder="' +
      new Array(CODE_LEN + 1).join('·') + '">' +
      '<span class="otpg-code-bar" data-bar></span>' +
      '</div>' +
      '<div class="otpg-status" data-status><span class="otpg-spinner"></span><span>جارٍ التحقق</span></div>' +
      '<div class="otpg-msg" data-msg2></div>' +
      '<div class="otpg-meta">' +
      '<span data-timer></span>' +
      '<button type="button" class="otpg-link" data-resend style="display:none">إعادة إرسال الرمز</button>' +
      '</div>' +
      '<div class="otpg-change">رقم غير صحيح؟ <button type="button" data-back>تغيير الرقم</button></div>' +
      '</div>' +

      '</div>';

    document.body.appendChild(overlay);

    els.overlay = overlay;
    els.panel = overlay.querySelector('.otpg-panel');
    els.close = overlay.querySelector('.otpg-close');
    els.step1 = overlay.querySelector('[data-step="1"]');
    els.step2 = overlay.querySelector('[data-step="2"]');
    els.phone = overlay.querySelector('[data-phone]');
    els.send = overlay.querySelector('[data-send]');
    els.msg1 = overlay.querySelector('[data-msg1]');
    els.code = overlay.querySelector('[data-code]');
    els.bar = overlay.querySelector('[data-bar]');
    els.status = overlay.querySelector('[data-status]');
    els.msg2 = overlay.querySelector('[data-msg2]');
    els.timer = overlay.querySelector('[data-timer]');
    els.resend = overlay.querySelector('[data-resend]');
    els.back = overlay.querySelector('[data-back]');
    els.phoneLabel = overlay.querySelector('[data-phone-label]');
    els.codeWrap = overlay.querySelector('.otpg-code-wrap');

    if (PREFILL) els.phone.value = PREFILL;

    bindModal();
  }

  /* ---------------------------------------------------------
     5) فتح / غلق
     --------------------------------------------------------- */

  var lastFocused = null;

  function openModal(trigger) {
    buildModal();
    state.trigger = trigger || null;
    lastFocused = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    els.overlay.classList.add('is-open');
    setTimeout(function () {
      els.phone.focus();
    }, 60);
  }

  function closeModal() {
    if (!els.overlay) return;
    els.overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    stopTimer();
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function showStep(n) {
    els.step1.classList.toggle('is-active', n === 1);
    els.step2.classList.toggle('is-active', n === 2);
  }

  /* ---------------------------------------------------------
     6) العدّاد
     --------------------------------------------------------- */

  function stopTimer() {
    if (state.timerId) clearInterval(state.timerId);
    state.timerId = null;
  }

  function startTimer(sec) {
    var left = sec || RESEND_SEC;
    stopTimer();
    els.resend.style.display = 'none';
    els.timer.style.display = 'inline';

    function tick() {
      els.timer.textContent = 'يمكنك طلب رمز جديد بعد ' + left + ' ثانية';
      if (left <= 0) {
        stopTimer();
        els.timer.style.display = 'none';
        els.resend.style.display = 'inline-block';
        els.resend.disabled = false;
        els.resend.textContent = 'إعادة إرسال الرمز';
      }
      left--;
    }
    tick();
    state.timerId = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------
     7) منطق الإرسال والتحقق
     --------------------------------------------------------- */

  function setMsg(el, text, kind) {
    el.textContent = text || '';
    el.className = 'otpg-msg' + (kind ? ' is-' + kind : '');
  }

  function updateBar() {
    var pct = (els.code.value.length / CODE_LEN) * 100;
    els.bar.style.width = pct + '%';
  }

  function sendCode(isResend) {
    var phone = normalizePhone(els.phone.value);

    if (!isValidSaudi(phone)) {
      setMsg(els.msg1, 'أدخل رقم جوال سعودي صحيح يبدأ بـ 05', 'error');
      els.phone.focus();
      return;
    }

    state.phone = phone;
    var btn = isResend ? els.resend : els.send;
    btn.disabled = true;
    var oldText = btn.textContent;
    btn.textContent = 'جارٍ الإرسال…';

    postJson(WORKER + '/otp/send', { phone: phone }).then(function (res) {
      btn.disabled = false;
      btn.textContent = oldText;

      if (!res || !res.ok) {
        setMsg(isResend ? els.msg2 : els.msg1, (res && res.message) || 'تعذّر إرسال الرمز. حاول مرة أخرى.', 'error');
        return;
      }

      els.phoneLabel.textContent = phone;
      setMsg(els.msg1, '');
      setMsg(els.msg2, isResend ? 'تم إرسال رمز جديد.' : '');
      showStep(2);
      els.code.value = '';
      updateBar();
      startTimer(RESEND_SEC);
      setTimeout(function () { els.code.focus(); }, 80);
      listenWebOtp();
    });
  }

  function verifyCode() {
    if (state.busy) return;
    var code = els.code.value.trim();
    if (code.length !== CODE_LEN) return;

    state.busy = true;
    els.codeWrap.classList.remove('is-error');
    els.codeWrap.classList.add('is-verifying');
    els.status.classList.add('is-on');
    els.code.disabled = true;
    setMsg(els.msg2, '');

    postJson(WORKER + '/otp/verify', { phone: state.phone, code: code }).then(function (res) {
      if (res && res.ok) {
        writeStore(state.phone, res.token);
        els.status.querySelector('span:last-child').textContent = 'تم التأكيد';
        setMsg(els.msg2, 'تم تأكيد رقمك. جارٍ المتابعة إلى الدفع…', 'ok');
        stopTimer();
        els.timer.style.display = 'none';
        els.resend.style.display = 'none';

        syncCartAttributes(state.phone).then(function () {
          setTimeout(function () {
            closeModal();
            resume();
          }, 350);
        });
        return;
      }

      state.busy = false;
      els.status.classList.remove('is-on');
      els.codeWrap.classList.remove('is-verifying');
      els.codeWrap.classList.add('is-error');
      els.code.disabled = false;
      els.code.value = '';
      updateBar();
      setMsg(els.msg2, (res && res.message) || 'الرمز غير صحيح. حاول مرة أخرى.', 'error');
      setTimeout(function () { els.code.focus(); }, 60);
    });
  }

  // قراءة الكود تلقائيًا من الرسالة (أندرويد/كروم)
  function listenWebOtp() {
    if (!('OTPCredential' in window) || !navigator.credentials) return;
    try {
      var ac = new AbortController();
      setTimeout(function () { try { ac.abort(); } catch (e) {} }, 90000);
      navigator.credentials
        .get({ otp: { transport: ['sms'] }, signal: ac.signal })
        .then(function (otp) {
          if (otp && otp.code) {
            els.code.value = String(otp.code).replace(/\D/g, '').slice(0, CODE_LEN);
            updateBar();
            if (els.code.value.length === CODE_LEN) verifyCode();
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* ---------------------------------------------------------
     8) ربط أحداث البوب أب
     --------------------------------------------------------- */

  function bindModal() {
    els.close.addEventListener('click', closeModal);

    els.overlay.addEventListener('click', function (e) {
      if (e.target === els.overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.overlay.classList.contains('is-open')) closeModal();
    });

    els.send.addEventListener('click', function () { sendCode(false); });

    els.phone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sendCode(false); }
    });

    els.resend.addEventListener('click', function () { sendCode(true); });

    els.back.addEventListener('click', function () {
      stopTimer();
      showStep(1);
      setMsg(els.msg2, '');
      els.code.value = '';
      updateBar();
      setTimeout(function () { els.phone.focus(); }, 60);
    });

    els.code.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, CODE_LEN);
      els.codeWrap.classList.remove('is-error');
      updateBar();
      if (this.value.length === CODE_LEN) verifyCode();
    });
  }

  /* ---------------------------------------------------------
     9) الاعتراض واستئناف الإجراء
     --------------------------------------------------------- */

  function findTarget(e) {
    var path = (e.composedPath && e.composedPath()) || [e.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1 || !node.closest) continue;
      var hit = node.closest(ALL_SELECTOR);
      if (hit) return hit;
    }
    return null;
  }

  function isBuyNow(el) {
    return !!(el.matches(BUYNOW_SELECTOR) || el.closest('.shopify-payment-button'));
  }

  // استئناف الإجراء الأصلي بعد التأكيد
  function resume() {
    var el = state.trigger;
    state.busy = false;

    if (el && document.contains(el)) {
      el.click(); // دلوقتي isVerified() = true فالنقرة هتعدي عادي
      return;
    }
    window.location.href = ROOT.replace(/\/$/, '') + '/checkout';
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var el = findTarget(e);
      if (!el) return;

      var store = readStore();

      if (store) {
        // متحقق بالفعل — نتأكد إن الرقم مترحّل على السلة الحالية
        if (!isBuyNow(el) && !el.__otpgSynced) {
          el.__otpgSynced = true;
          syncCartAttributes(store.phone);
        }
        return; // يكمل عادي
      }

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openModal(el);
    },
    true // capture — قبل هاندلرز الثيم و Shopify
  );

  // احتياطي: إرسال فورم السلة بالكيبورد (Enter)
  document.addEventListener(
    'submit',
    function (e) {
      var submitter = e.submitter;
      if (!submitter || !submitter.closest) return;
      if (!submitter.closest(CART_SELECTOR)) return;
      if (isVerified()) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openModal(submitter);
    },
    true
  );

  /* ---------------------------------------------------------
     10) أدوات للتشخيص
     --------------------------------------------------------- */

  window.OTPGate = {
    reset: function () {
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      console.log('[OTP Gate] تم مسح حالة التحقق.');
    },
    status: function () {
      return readStore();
    },
    open: function () {
      openModal(null);
    }
  };

  if (DEBUG) console.log('[OTP Gate] جاهز.', { worker: WORKER, verified: isVerified() });
})();